(function () {
  const MARQUEE_SELECTOR = '.logo-banner--full-width .logo-banner__marquee';
  const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  function isMobileMarquee() {
    return MOBILE_MQ.matches;
  }

  function initMarquee(marquee) {
    const track = marquee.querySelector('.logo-banner__marquee-track');
    if (!track) return;

    const items = track.querySelectorAll(':scope > li');
    if (items.length < 2) return;

    const cloneIndex = Math.floor(items.length / 2);
    const firstClone = items[cloneIndex];
    if (!firstClone) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateOffset() {
      const offset = firstClone.offsetLeft;

      if (offset > 0) {
        track.style.setProperty('--logo-banner-marquee-offset', `${offset}px`);
      }

      const shouldAnimate = isMobileMarquee() && !reducedMotion && offset > 0;

      if (shouldAnimate) {
        track.classList.add('logo-banner__marquee-track--active');
      } else {
        track.classList.remove('logo-banner__marquee-track--active');
        track.style.transform = '';
      }
    }

    if (track.dataset.marqueeReady === '1') {
      updateOffset();
      return;
    }

    track.dataset.marqueeReady = '1';
    updateOffset();

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', updateOffset);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(updateOffset);
    }

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => updateOffset());
      observer.observe(track);
      observer.observe(firstClone);
    } else {
      window.addEventListener('resize', updateOffset);
    }

    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', updateOffset, { once: true });
      }
    });
  }

  function initAll() {
    document.querySelectorAll(MARQUEE_SELECTOR).forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
